<template>
  <div id="home" class="home">
    <div id="section1">
      <v-container fluid class="bg-home home-banner">
        <div class="section1">
          <div class="banner-text">
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-row>
                  <div class="home-title">
                    <h3>{{ title }}</h3>
                  </div>
                </v-row>
                <v-row justify="center">
                  <v-btn
                    rounded
                    color="#078b4b"
                    x-large
                    v-scroll-to="'#section2'"
                  >
                    <v-icon class="mr-3" color="white">mdi-eye</v-icon>
                    <span class="menu">{{ btnDetail }}</span>
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" sm="12" class="hidden-img">
                <v-img
                  style="z-index: 1"
                  src="@/assets/images/home/17.png"
                ></v-img>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-container>
    </div>
    <div id="section2">
      <v-container fluid class="pb-16" style="background-color: white">
        <v-container>
          <div class="section2 bodyContent pb-16">
            <v-row class="ma-0 py-10">
              <h1>{{ province }}</h1>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
                lg="4"
                class=""
                v-for="item in siteInfo"
                :key="item.id"
              >
                <router-link
                  :to="redirectToSiteSelect(item.id)"
                  style="text-decoration: none"
                >
                  <DgrCardOverlay
                    :title="item.cardTitle"
                    :subTitle="item.cardSubTitle"
                    :description="item.cardDescription"
                    :image="item.cardImage"
                  >
                  </DgrCardOverlay>
                </router-link>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-container>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// * IMPORT COMPONENTS
import DgrCardOverlay from "@/components/helpers/DgrCardOverlay.vue";

// * IMPORT CONFIG .JS FILE(S)
import { siteInfo, project, province } from "@/helpers/constants.js";

export default {
  name: 'Home',
  components: {
    DgrCardOverlay
  },
  data: function () {
    return {
      siteInfo: siteInfo,
      title: project,
      province: province,
      btnDetail: "ดูรายละเอียดคลิก",
      cardBtnDetail: "ดูรายละเอียดเพิ่มเติม",
    }
  },
  methods: {
    redirectToSiteSelect(siteId) {
      return "scada/"+siteId;
    }
  },
}
</script>
